/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Template
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// May contain unused imports in some cases
// @ts-ignore
import type { TranscriptionConfig } from './transcription-config';

/**
 *
 * @export
 * @interface SetRecognitionConfig
 */
export interface SetRecognitionConfig {
  /**
   *
   * @type {string}
   * @memberof SetRecognitionConfig
   */
  message: SetRecognitionConfigMessageEnum;
  /**
   *
   * @type {TranscriptionConfig}
   * @memberof SetRecognitionConfig
   */
  transcription_config: TranscriptionConfig;
}

export const SetRecognitionConfigMessageEnum = {
  SetRecognitionConfig: 'SetRecognitionConfig',
} as const;

export type SetRecognitionConfigMessageEnum =
  (typeof SetRecognitionConfigMessageEnum)[keyof typeof SetRecognitionConfigMessageEnum];
